define('windows',[
  'module',
  'settings',
  'underscore',
  'windowView',
  'windowModalView',
  'windowsManagmentView'
], function (
  Module,
  Settings,
  _,
  WindowView,
  WindowModalView,
  WindowsManagmentView
) {
  'use strict';

  Module.exports = {

    init: function (app) {
      this.app = app;
      this.views = [];
      this.popupViews = [];
      this.zIndex = 500;
      this.toolsView = null;
      this.modalView = null;
      this.navigation = null;
    },

    show: function (container, fullSizeContainer, modalContainer) {
      this.container = container;
      this.fullSizeContainer = fullSizeContainer;

      this.modalView = new WindowModalView();
      modalContainer.append(this.modalView.render().el);
      this.modalContainer = modalContainer;

      this.managmentView = new WindowsManagmentView({
        windows: this
      });

      this.container.append(this.managmentView.render().el);
    },

    open: function (params) {
      var config = {
        margin: false,
        modal: false
      };

      if (params.configName && Settings.windows[params.configName])
        config = _.extend(config, Settings.windows[params.configName]);

      if(params.top)
        config.top = params.top;
      if(params.left)
        config.left = params.left;
      if(params.width)
        config.width = params.width;
      if(params.height)
        config.height = params.height;
      if(params.minWidth)
        config.minWidth = params.minWidth;
      if(params.maxWidth)
        config.maxWidth = params.maxWidth;
      if(params.minHeight)
        config.minHeight = params.minHeight;
      if(params.maxHeight)
        config.maxHeight = params.maxHeight;
      if(params.margin)
        config.margin = params.margin;
      if(params.modal)
        config.modal = params.modal;
      if(params.fullSize)
        config.fullSize = params.fullSize;
      
      var windowView = null;

      if(!config.modal) {
        _.each(this.views, function (view) {
          if (view.id === params.id)
            windowView = view;
        }, this);
      }

      this.onClose = params.onClose;

      if (!windowView) {
        windowView = new WindowView({
          windows: this,
          id: params.id,         
          config: config,
          zIndex: this.zIndex + this.views.length,
          bodyClass: params.bodyClass,
          className: (params.className ? params.className + ' ' : '') + 'window-view',
          navigation: params.navigation,
          createBodyView: this.createBodyView(params),          
          title: params.title
        });

        if (!config.modal) {
          this.views.push(windowView);
          this.container.append(windowView.render().el);

          if (this.toolsView)
            this.toolsView.render();
        } else {
          this.modalView.open(windowView);
        }          
      }   
      
      if (!config.modal) {
        windowView.show();
        windowView.unminimize();
        windowView.focus();        
      }
    },

    createBodyView: function(params) {
      var defer = $.Deferred();       

      if(params) {
        if (typeof params.view === 'function') {
          var paramView = params.view();
          if(paramView && paramView.done) {
            paramView.done(_.bind(function(view) {
              defer.resolve(view);
            }, this));
          } else {
            defer.resolve(paramView);
          }
        } else {
          defer.resolve(params.view);
        }
      }
      
      return defer.promise();
    },

    close: function (windowView) {
      if (!windowView.config.modal) {
        this.views.splice(this.views.indexOf(windowView), 1);

        _.each(this.views, function (windowViewToMove, index) {
          windowViewToMove.zIndex = this.zIndex + index;
          windowViewToMove.$el.css('z-index', windowViewToMove.zIndex);
        }, this);        

        if (this.toolsView)
          this.toolsView.render();

        windowView.destroy();
     
        this.toolsView.setDevideScreen();      
      } else {
        this.modalView.close();
      }

      if (this.onClose)
        this.onClose();        
      
      if(windowView.view && windowView.view.onWindowClose)
        windowView.view.onWindowClose();

      this.setNavigation();
    },

    focus: function (windowView) {
      if (windowView.config.modal)
        return;

      if (this.views.indexOf(windowView) !== this.views.length-1) {
        this.views.splice(this.views.length, 0, this.views.splice(this.views.indexOf(windowView), 1)[0]);
        _.each(this.views, function (windowViewToMove, index) {
          windowViewToMove.zIndex = this.zIndex + index;
          windowViewToMove.$el.css('z-index', windowViewToMove.zIndex);
        }, this);
      }

      this.setNavigation();
    },

    setNavigation: function() {      
      var focusedView = this.getFocusedView();

      if(focusedView && focusedView.options.navigation) {
        focusedView.options.navigation(focusedView, focusedView.view).done(_.bind(function(uri) {
          this.app.navigate(uri, {trigger: false});
        }, this));          
      }
      else if(this.app.currentUrl)
        this.app.navigate(this.app.currentUrl, {trigger: false});      
    },

    minimize: function () {
      this.setNavigation();
      this.toolsView.setDevideScreen();    
    },

    minimizeAll: function () {
      _.each(this.views, function (view) {
        view.minimize();
      }, this);
    },

    closeAllUnminimized: function () {
      var viewsToClose = [];
      _.each(this.views, function (view) {
        if (!view.isMinimized())
          viewsToClose.push(view);
      }, this);
      _.each(viewsToClose, function (view) {
        this.close(view);
      }, this);
    },

    getFocusedView: function () {
      var focusedView = null;

      _.each(this.views, function (view) {
        if (!view.isMinimized()) {
          if (!focusedView)
            focusedView = view;
          else {
            if (view.zIndex > focusedView.zIndex)
              focusedView = view;
          }
        }
      }, this);

      return focusedView;
    },

    divideScreen: function () {
      var visibleViews = [];
      this.views.forEach(_.bind(function (view) {
        if(!view.isMinimized())
          visibleViews.push(view);
      }, this));

      if(this.toolsView.divideScreen && visibleViews.length > 1) {     
        var width = this.container.width() / visibleViews.length;
        var height = this.container.height();

        _.each(visibleViews, function (view, index) {
          view.dividedSize = true;
          view.dividedSceenLeft = index * width;
          view.dividedSceenWidth = width;   
          view.dividedSceenHeight = height;
          view.updateSize();         
        }, this);
      } else {
        _.each(visibleViews, function (view) {
          view.dividedSize = false;
          view.dividedSceenLeft = 0;
          view.dividedSceenWidth = 0;     
          view.dividedSceenHeight = 0;
          view.updateSize();    
        }, this);
      }
    }
  };
});
